import React from "react";
import { Button } from "antd";
import shiftEdit from "../../../../assets/svg/shiftEdit.svg"; 
import trash from "../../../../assets/svg/trash.svg";

const ShiftHeader = ({
  shift,
  stats,
  statsColor,
  getShiftDate,
  openEditShiftPopup,
  setShiftToDelete,
  setShowDeleteShiftModal,
}) => {
  return (
    <div className="flex justify-between items-center border-b border-b-[#E3E1E1] pb-2">
      {/* Shift header and shift details */}
      <div className="flex items-center">
        <p className="text-grayBlack text-xl font-bold mr-3">
          {shift?.name}
        </p>

        <div className="mx-3">
          <span
            className={`border border-transparent rounded-[4px] py-[2px] px-[3px] text-subText font-medium ${statsColor}`}
          >
            {stats}
          </span>
        </div>

        <p className="mx-3 text-cadetBlue text-[14px] font-medium">
          {getShiftDate(
            shift?.startAt,
            shift?.startTZ,
            shift?.endAt,
            shift?.endTZ
          )}
        </p>

        <p className="mx-3 font-inter text-cadetBlue text-[14px] font-medium">
          Shift location:{" "}
          {shift?.primaryVenueAddressSpace?.display_name}
        </p>
      </div>

      {/* Shift action buttons */}
      <div className="flex items-center">
        <Button
          className="flex font-inter font-medium text-sm text-fontGray border rounded-[8px] py-[6px] pr-[10px] pl-[6px] mr-3 hover:!text-fontGray !border-grayLight"
          onClick={() => openEditShiftPopup(shift?.UUID)}
          icon={
            <img
              src={shiftEdit}
              style={{
                marginTop: "auto",
                marginBottom: "auto",
                marginLeft: "5px",
                marginRight: "5px",
              }}
              alt="edit shift"
            />
          }
        >
          Edit
        </Button>

        <Button
          className="px-2 border-[#98a2b380] rounded-[8px] shadow-attachment"
          onClick={() => {
            setShiftToDelete(shift?.UUID);
            setShowDeleteShiftModal(true);
          }}
        >
          <img src={trash} alt="delete-shift" />
        </Button>
      </div>
    </div>
  );
};

export default ShiftHeader;
